<template>
    <div class="input-box" style="display: flex;justify-content: space-around;align-items: center;" :style="{ fontSize: btn.fontSize+'px', lineHeight: btn.lineHeight, textAlign: btn.textAlign, backgroundColor: btn.backgroundColor, color: btn.fontColor, paddingBottom: btn.paddingBottom+'px' }">
        <div style="width: calc(100% - 20px)">
            <p :style="{ fontSize: btn.fontSize }" style="margin: 10px 10px 5px 15px;font-weight: bold;">{{ btn.fieldTitle }}</p>
            <input :placeholder="btn.placeholder" :type="btn.checkbox ? 'checkbox' : 'text'" style="background-color: white;width: calc(95% - 30px);margin-left:15px;padding-left:10px;font-size: 22px;position: relative;top:-2px" :style="{ paddingTop: btn.inputPadding+'px', paddingBottom: btn.inputPadding+'px', fontSize: btn.inputFontSize+'px' }" />
        </div>
    </div>
</template>

<script>

export default {
    props: ['btn'],
    data () {
        return {
            value: ''
        }
    },
    mounted () {
        
    },
    methods: {
        keyUp ( e ) {

        }
    }
}    
</script>